module.exports = __webpack_public_path__ + "img/success-ico.60e60124.svg";